import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGlossaryStore = defineStore('glossary', () => {
  const isOpen = ref(false);
  const currentTerm = ref<string | null>(null);

  function openGlossary(term?: string) {
    if (term) currentTerm.value = term;
    isOpen.value = true;
  }

  function closeGlossary() {
    isOpen.value = false;
    currentTerm.value = null;
  }

  return {
    isOpen,
    currentTerm,
    openGlossary,
    closeGlossary,
  };
}); 